import React from "react";
import { Form } from "@redriver/cinnamon";
import { getMeteredServices } from "./actions";

const MeteredServiceDropdown = ({
  excludeMeteredServiceIds,
  dealerOfficeId,
  isLargeFormat,
  availableOnly,
  useDisplayName,
  ...props
}) => {
  return (
    <Form.Dropdown
      {...props}
      lookupAction={getMeteredServices}
      lookupParams={{
        excludeMeteredServiceIds,
        dealerOfficeId,
        isLargeFormat,
        availableOnly,
      }}
      lookupOptions={{
        transform: (data) =>
          data.map((i) => ({
            value: i.id,
            text: `${i.code} - ${
              useDisplayName ? i.displayName || i.name : i.name
            }`,
            disabled:
              availableOnly && i.status !== "Available" && i.status !== 1,
          })),
      }}
    />
  );
};

export default MeteredServiceDropdown;
